import { IconFormNames } from 'shared/assets/icons';
import * as yup from 'yup';

export type SmartListForm = {
  name?: string;
  color?: string;
  icon: IconFormNames;
};

export const validationSchema: yup.ObjectSchema<SmartListForm> = yup.object({
  name: yup.string().required(),
  color: yup.string().optional(),
  icon: yup
    .mixed<IconFormNames>()
    .oneOf(Object.values(IconFormNames) as IconFormNames[])
    .required(),
});

export type SmartListFormFields = yup.InferType<typeof validationSchema>;
